<template>
  <multiselect
    :options="branchOptions"
    :show-labels="false"
    :allow-empty="false"
    placeholder
    v-bind="{ value }"
    @input="updateValue"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  props: ['value'],

  components: {
    Multiselect
  },

  computed: {
    ...mapState('applications/branches', ['branches']),

    branchOptions () {
      return this.branches.map(({ name }) => name)
    }
  },

  async created () {
    await this.getBranches()
  },

  methods: {
    ...mapActions('applications/branches', ['getBranches']),

    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>
